'use client';

import { useEffect, useState } from "react";
import styles from "./ua.module.scss";
import Image from "next/image";
import Button from "../button/Button";
import Icon from "../icon/Icon";

export default function Gallery(props) {
  
  const [imageIndex,setImageIndex] = useState(0)
  
  useEffect(() => {
  })
  
  const onSelect = (e, index) => {
    e.preventDefault()
    setImageIndex(index)
  }

  const move = (factor) => {
    if (imageIndex + factor >= 0 && imageIndex + factor < props.items.length) {
      setImageIndex(imageIndex + factor)
      document.getElementById("gt__" + (imageIndex + factor)).scrollIntoView({ behavior: 'smooth', block: 'nearest'})
    }
  }
  
  return ( <div className={ styles.g }>
    <div className={styles.gM}>
      <Image src={props.items[imageIndex].image} alt={props.name + ' - Photo ' + (imageIndex + 1)}
        placeholder={ props.placeholder } className={ props.items[imageIndex].flipHorizontal ? styles.gfliph : ''}
        fill={'object-fit'} style={{ maxWidth: "100%", objectFit: "contain" }} priority={true} sizes={'1200x1200'}></Image>
      <Button theme="none" className={styles.garr + ' ' + (imageIndex > 0 ? styles.garrs : '')} onClick={e => move(-1)}>
        <Icon name="chevron-left"></Icon>
      </Button>
      <Button theme="none" className={styles.garr + ' ' + (imageIndex < props.items.length - 1 ? styles.garrs : '')} onClick={e => move(1)}>
        <Icon name="chevron-right"></Icon>
      </Button>
    </div>
    { props.items.length > 1 &&
    <div id=""className={styles.vtSr}>
      { props.items.map((item,index) => (
        <Button id={'gt__' + index} plain={true} key={index} className={styles.vtTh + ' ' + (index == imageIndex ? styles.vtThSel : '')} onClick={e => onSelect(e,index)} label={props.name + ' - Photo ' + (index + 1)}>
          <Image src={item.image} placeholder={props.placeholder} alt={props.name + ' - Photo ' + (index + 1)} fill={'object-fit'} style={{ maxWidth: "100%", objectFit: "contain" }} priority={true} sizes={'240x240'}></Image>
        </Button>
      ))}
   </div>
    }
  </div>
  )
  
}